import { Pipe, PipeTransform } from '@angular/core';
import { Params } from '@angular/router';
import { customFilterParams } from '@features/product-filter/product-filter.config';

@Pipe({
    name: 'getQueryParamForLink',
    standalone: true
})
export class GetQueryParamForLinkPipe implements PipeTransform {
    transform(searchString: string): Params {
        return { [customFilterParams.searchQuery]: searchString };
    }
}
